import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme, App as AntdApp } from 'antd';
import idID from 'antd/locale/id_ID';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import socketService from './services/socket';
import { configureAlertNotifications } from './utils/alertPrefs';
import 'antd/dist/reset.css';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    configureAlertNotifications();

    const token = localStorage.getItem('token');
    if (token) {
      verifyToken(token);
    } else {
      setLoading(false);
    }

    return () => {
      socketService.disconnect();
    };
  }, []);

  const verifyToken = async (token) => {
    try {
      const { authAPI } = await import('./services/api');
      const response = await authAPI.verifyToken();
      if (response.success) {
        setUser(response.data.user);
        socketService.connect(token);
        socketService.subscribeToTargets();
      }
    } catch (error) {
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (userData, token) => {
    setUser(userData);
    localStorage.setItem('token', token);
    socketService.connect(token);
    socketService.subscribeToTargets();
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('token');
    socketService.disconnect();
  };

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  return (
    <ConfigProvider
      locale={idID}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AntdApp>
        <Router>
          <div className="App">
            <Routes>
              <Route
                path="/login"
                element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
              />
              <Route
                path="/*"
                element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}
              />
            </Routes>
          </div>
        </Router>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;